// extracted by mini-css-extract-plugin
export default {"card":"styles_card__ECaQB","card__name":"styles_card__name__iXWwL","card__detail__text":"styles_card__detail__text__CRO+U","card__label":"styles_card__label__kF4O9"};